import { render, staticRenderFns } from "./channelMview.vue?vue&type=template&id=747221d2&"
import script from "./channelMview.vue?vue&type=script&lang=js&"
export * from "./channelMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports